import StudentDatabase from './StudentDatabase';

export default StudentDatabase;
